import React from 'react';
import Navigation from './navigation/Navigation';
import ContactInterface from './contactSection/ContactInterface';
import ConversationInterface from './conversationSection/ConversationInterface';
import Welcome from './conversationSection/Welcome';
import ProfilInterface from './profilSection/Profil';
import ProfilContact from './profilSection/ProfilContact';
import ResearchContactInterface from './researchContactSection/ResearchContactInterface';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import '../styles/app.css';
import '../styles/contactStyle.css';
import '../styles/conversationStyle.css';
import '../styles/welcome.css';
import '../styles/profilStyle.css';
import '../styles/researchContactStyle.css';
import { BaseContext, ConversationContext } from './contexts/baseContext';
import $ from 'jquery';

class Base extends React.Component {
  constructor() {
    super();

    let height = window.innerHeight;
    let width = window.innerWidth;
    let conv = window.innerWidth < 576 ? "hidden" : "visible";
    let contactHeight = width <= 700 ? height - 120 : height - 60;
    let profilHeight = height - 200;

    this.state = {
      discussions: [
        {
          contact: {
            id: 1,
            nom: "Nina",
            photo: "nature.png",
          },

          active: "",

          messages: [
            {
              content: "hello",
              date: "9:09",
              type: "received",
              id: 1,
              idMessageIndexed: null
            }
          ]
        },

        {
          contact: {
            id: 2,
            nom: "Donald",
            photo: "face4.png",
          },

          active: "",

          messages: [
            {
              content: "dilane, j'ai faim 📢📢📢",
              date: "12:07",
              type: "received",
              id: 1,
              idMessageIndexed: null
            },
            {
              content: "tu as recu 15.000 Fcfa nor ?? va manger ca, et arrete de crier dans mes oreille",
              date: "12:09",
              type: "sended",
              id: 2,
              idMessageIndexed: null
            }
          ]
        },

        {
          contact: {
            id: 3,
            nom: "Maman",
            photo: "machette2.png",
          },

          active: "",

          messages: [
            {
              content: "Hello dilane",
              date: "21:04",
              type: "received",
              id: 1,
              idMessageIndexed: null
            },
            {
              content: "salut Maman",
              date: "21.06",
              type: "sended",
              id: 2,
              idMessageIndexed: 1
            },
            {
              content: "comment tu vas ?",
              date: "21:07",
              type: "sended",
              id: 3,
              idMessageIndexed: null
            },
            {
              content: "je vais bien, juste pour te souhaiter",
              date: "21:44",
              type: "received",
              id: 4,
              idMessageIndexed: 3
            },
            {
              content: "bonne nuit",
              date: "21:45",
              type: "received",
              id: 5,
              idMessageIndexed: null
            }
          ]
        }
      ],

      currentuser: {
        nom: "Dilane",
        photo: "nature2.png"
      },

      discussion: null,

      navigation: {
        contacts: "visible",
        conversation: conv,
        profil: "hidden",
        profilContact: "hidden",
        parametre: "hidden",
        addContact: "hidden",
        searchContact: "hidden",
      },

      screen: {
        conversationBody: height - 120,
        contactBody: contactHeight,
        section: height,
        profilBody: profilHeight,
        messageEditorBottom: 0
      },

      idMessageIndexed: null,

      interfaceType: null
    }
  }

  componentDidMount() {
    window.addEventListener('resize', () => {
      let screen = this.state.screen;
      let height = window.innerHeight;

      screen.conversationBody = height - 120;
      screen.section = height;
      screen.profilBody = height - 200;
      screen.contactBody = window.innerWidth <= 700 ? height - 120 : height - 60;

      this.setState({ screen });
      this.resizeInterface();
    });

    // managing of progressive loading of images
    let imagesToLoad = document.querySelectorAll('img[data-src]');
    const loadImages = (image) => {
      console.log(image);
      image.setAttribute('src', image.getAttribute('data-src'));
      image.onload = () => {
        image.removeAttribute('data-src');
      };
    };

    for (let image of imagesToLoad) {
      loadImages(image);
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', () => this.resizeInterface());
  }

  choiceContact = (id) => {
    let discussions = [...this.state.discussions];

    discussions.forEach(discussion => {
      discussion.active = "";
    })
    discussions[id-1].active = "active";

    this.setState({ discussion: id, idMessageIndexed: null, discussions });

    this.switchInterface("conversation");
  }

  switchInterface = (interfaceName) => {
    let nav = this.state.navigation;

    if (interfaceName === "contacts") {
      if (window.innerWidth < 576) {
        nav.contacts = "visible";
        nav.conversation = "hidden";
        nav.profil = "hidden";
        nav.profilContact = "hidden";
        nav.searchContact = "hidden";
      } else {
        nav.contacts = "visible";
        nav.profil = "hidden";
        nav.profilContact = "hidden";
        nav.searchContact = "hidden";
      }
    } else if (interfaceName === "conversation") {
      if (window.innerWidth < 576) {
        nav.contacts = "hidden";
        nav.conversation = "visible";
      } else {
        nav.conversation = "visible";
      }
    } else if (interfaceName === "profil") {
      nav.contacts = "hidden";
      nav.profil = "visible";
      nav.profilContact = "hidden";
      nav.addContact = "hidden";
      nav.searchContact = "hidden";
    } else if (interfaceName === "search-contact" || interfaceName === "add-contact") {
      nav.contacts = "hidden";
      nav.profil = "hidden";
      nav.profilContact = "hidden";
      nav.searchContact = "visible";
    } else if (interfaceName === "profil-contact") {
      nav.contacts = "hidden";
      nav.profil = "hidden";
      nav.profilContact = "visible";
      nav.searchContact = "hidden";
    }

    this.setState({ navigation: nav });
  }

  resizeInterface = () => {
    let nav = this.state.navigation;

    if (window.innerWidth >= 576) {
      if (nav.profil === "visible" || nav.profilContact === "visible") {
        nav.conversation = "visible";
        nav.contacts = "hidden";
      } else if (nav.contacts === "visible") {
        nav.conversation = "visible";
        nav.profil = "hidden";
      } else if (nav.searchContact === "visible" || nav.addContact === "visible") {
        nav.conversation = "visible";
        nav.contacts = "hidden";
      } else if (nav.profil === "hidden" && nav.contacts === "hidden") {
        nav.conversation = "visible";
        nav.contacts = "visible";
      }
    }

    this.setState({ navigation: nav });
  }

  resizeSectionConversation = (showEmoji) => {
    let screen = this.state.screen;
    let height = window.innerHeight;
    console.log(showEmoji);

    if (showEmoji) {
      screen.conversationBody = height - 320;
      screen.messageEditorBottom = 253;
    } else {
      screen.conversationBody = height - 120;
      screen.messageEditorBottom = 0;
    }

    this.setState({ screen });
  }

  getMessages() {
    const discussions = [...this.state.discussions];

    let index = discussions.findIndex(discussion => discussion.contact.id === this.state.discussion);

    if (index !== undefined)
      return discussions[index].messages;

    return null;
  }

  // this function take a message and store it in the state
  sendMessage = (msg, idMessageIndexed) => {
    const idDiscussion = this.state.discussion;
    let discussions = [...this.state.discussions];

    if (msg.length > 0) {
      let index = discussions.findIndex(discus => discus.contact.id === idDiscussion);

      if (index !== undefined) {
        let date = new Date();
        let dateString = "";
        let hours = date.getHours();
        let minutes = date.getMinutes();

        // here i format the date
        if (hours < 10)
          dateString += "0" + hours;
        else
          dateString += hours;

        dateString += ":";
        if (minutes < 10)
          dateString += "0" + minutes;
        else
          dateString += minutes;

        // here i crate the message object
        let message = {
          content: msg,
          date: dateString,
          type: "sended",
          id: discussions[index].messages[discussions[index].messages.length-1].id + 1,
          idMessageIndexed: idMessageIndexed !== null ? idMessageIndexed:null
        }

        discussions[index].messages.push(message);
        console.log(message);
      }

      this.setState({ discussions });

      // here we scroll to the bottom after the message stored
      $(function() {
        setTimeout(() => {
          document.querySelector(".section-conversation-body").scrollTo({
            top: document.querySelector(".section-conversation-body").scrollHeight,
            left: 100,
            behavior: 'smooth'
          });
        }, 10);
      });
    }
  }

  /**
   * this function remove the message from the state
   *
   */
  removeMessage = (id) => {
    // i copy the content of discussions table
    let discussions = [...this.state.discussions];

    // i find the index where the message is stored
    let index = discussions.findIndex(discus => discus.contact.id === this.state.discussion);

    let messages = [...discussions[index].messages];
    let indexMessage = messages.findIndex(msg => msg.id === id);

    // i remove the message with id property value
    messages.splice(indexMessage, 1);

    // i research all message that indexe the message which have been removed
    messages.forEach(msg => {
      if (msg.idMessageIndexed === id) {
        msg.idMessageIndexed = null;
      }
    });

    // i save the messages object inside the state
    discussions[index].messages = messages;

    this.setState({ discussions });
  }

  // this function change the value of the indexed message
  setIdMessageIndexed = (idMessage) => {
    this.setState({ idMessageIndexed: idMessage });
  }

  handleInterfaceType = (nameInterface) => {
    this.setState({ interfaceType: nameInterface });
  }

  render() {
    const index = this.state.discussion;
    const screen = this.state.screen;

    const baseConfig = {
      navigateTo: this.switchInterface,
      windowHeight: screen.section,
      profilSectionHeight: screen.profilBody,
      conversationBodyHeight: screen.conversationBody,
      contactBodyHeight: screen.contactBody,
      profilBodyHeight: screen.profilBody,
      messageEditorPositionBottom: screen.messageEditorBottom,
      resizeSectionConversation: this.resizeSectionConversation,
      currentUser: this.state.currentuser,
      touchContact: this.choiceContact,
      sendMessage: this.sendMessage,
      removeMessage: this.removeMessage,
      discussionId: this.state.discussion,
      setInterfaceType: this.handleInterfaceType
    };

    const secondConfig = {
      idMessageIndexed: this.state.idMessageIndexed,
      setIdMessageIndexed: this.setIdMessageIndexed
    }

    return (
      <BaseContext.Provider value={baseConfig}>
        <div className="container-fluid">
          <div className="row">
            <Navigation />
            <section
              className={`section-contacts col-sm-5 ${this.state.navigation.contacts}`}
              style={{ height: `${screen.section}px` }}
            >

              <ContactInterface
                discussions={this.state.discussions}
              />

            </section>

            <section
              className={`section-contacts col-sm-5 ${this.state.navigation.profil}`}
              style={{ height: `${screen.section}px` }}
            >
              <ProfilInterface />

            </section>

            <section
              className={`section-contacts col-sm-5 ${this.state.navigation.profilContact}`}
              style={{ height: `${screen.section}px` }}
            >
              <ProfilContact />

            </section>

            <section
              className={`section-contacts col-sm-5 ${this.state.navigation.searchContact}`}
              style={{ height: `${screen.section}px` }}
            >
              <ResearchContactInterface
                discussions={this.state.discussions}
                interfaceType={this.state.interfaceType}
              />
            </section>

            <ConversationContext.Provider value={secondConfig}>
              {
                this.state.discussion !== null ? (
                  <section
                    className={`section-conversation col col-sm ${this.state.navigation.conversation}`}
                    style={{ height: `${screen.section}px` }}
                  >
                    <ConversationInterface
                      messages={this.getMessages()}
                      contact={this.state.discussions[index-1].contact}
                      conversationResize={this.resizeSectionConversation}
                    />
                  </section>
                ) : <Welcome />
              }
            </ConversationContext.Provider>
          </div>
        </div>
      </BaseContext.Provider>
    );
  }
}

export default Base;
